(()=>{
 'use strict';
 // Natuzzi option rows use their exact supplier schematics so sizes,
 // mechanisms and modular geometry remain visually consistent. Verified
 // supplier photographs are retained for collection cards, product heroes
 // and galleries, not assigned to dropdown choices here.
})();
